import { InjectionToken } from '@angular/core';
import { Converter } from '@spartacus/core';
import {CustomStoreFinderSearchPage} from "../models/store-finder.model";

export const STORE_FINDER_SEARCH_PAGE_NORMALIZER = new InjectionToken<
  Converter<any, CustomStoreFinderSearchPage>
>('CustomStoreFinderSearchPageNormalizer');
